import { render, staticRenderFns } from "./ProductSupplier.vue?vue&type=template&id=7f988b46&scoped=true"
import script from "./ProductSupplier.vue?vue&type=script&lang=js"
export * from "./ProductSupplier.vue?vue&type=script&lang=js"
import style0 from "./ProductSupplier.vue?vue&type=style&index=0&id=7f988b46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f988b46",
  null
  
)

component.options.__file = "ProductSupplier.vue"
export default component.exports